import React,{Component} from 'react';

import Social from './Social';
import Contact from './sections/Contact';

import './FooterMobile.less';

const Footer = ({isActive,openAction,res}) => (
 <div id="footer-mobile" style={{transform: isActive ? 'translate3D(0,0,0)' : 'translate3D(0,calc(100% - 15px),0)', overflow: isActive ? 'scroll' : 'visible'}}>
    <div className="wrapper" onClick={openAction} >
    <Contact res={res}/>
    <div id="credits">
    Copyright 2017 the Prosecution &middot; Impressum
    <div className='premote'>powered by premote</div>
    <div className="initiativemusik">
    <img src="/img/sonstige/initiative_musik_footer.svg" alt="Initiative Musik"  />
    Gefördert durch die Initiative Musik gemeinnützige Projektgesellschaft mbH mit Projektmitteln der Beauftragten der Bundesregierung für Kultur und Medien.
    </div>
    </div>
    </div>
    <div id="toggle" onClick={openAction} />
  </div>


)

export default Footer



// WEBPACK FOOTER //
// ./src/components/FooterMobile.js